import styled from "styled-components";

export const FiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 16px;
  flex-wrap: wrap;
`;

export const FiltersLeftContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  flex: 1;
  padding: 5px 0;

  & > div > div {
    width: auto;
  }
`;

export const SearchContainer = styled.div`
  min-width: 200px;
`;

export const FiltersRightContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;


